// src/app/views/pages_admin/user_group/userGroup-routes.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const UserGroup = Loadable(lazy(() => import("./UserGroup")));

const routes = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/user-group`,
  element: <UserGroup />
}));

export default routes;